import Container from '@/components/atoms/Container'
import Icon from '@/components/atoms/Icon'
import {useEffect, useState} from 'react'
import styles from './Share.module.scss'

export default function Share() {
  const [windowLocation, setWindowLocation] = useState('')

  useEffect(() => {
    setWindowLocation(window?.location)
  })

  const copyCurrentUrl = async () => {
    try {
      await navigator.clipboard.writeText(windowLocation)
    } catch (e) {
      console.error('Failed to copy URL: ', e)
    }
  }

  return (
    <Container>
      <div className={styles.wrapper}>
        <div className={styles.title}>Teilen</div>
        <div className={styles.iconsWrapper}>
          <a
            target="_blank"
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${windowLocation}`}
            className={styles.icon}
            rel="noreferrer"
          >
            <Icon icon="linkedin" />
          </a>
          <a
            target="_blank"
            href={`https://www.facebook.com/sharer/sharer.php?u=${windowLocation}`}
            className={styles.icon}
            rel="noreferrer"
          >
            <Icon icon="facebook" />
          </a>
          <a
            target="_blank"
            href={`https://twitter.com/intent/tweet?url=${windowLocation}`}
            className={styles.icon}
            rel="noreferrer"
          >
            <Icon icon="twitter" />
          </a>

          <a
            target="_blank"
            href={`https://www.xing.com/spi/shares/new?url=${windowLocation}`}
            className={styles.icon}
            rel="noreferrer"
          >
            <Icon icon="xing" />
          </a>

          <span onClick={() => copyCurrentUrl()} className={styles.icon}>
            <Icon icon="link" />
          </span>
        </div>
      </div>
    </Container>
  )
}
